import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.6",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<rect width=\"8\" height=\"4\" x=\"5\" y=\"4.5\" rx=\"1\"></rect><path d=\"M7 8.5V22l2 2 2-2V8.5M20.5 4.5 24.83 7v5l-4.33 2.5-4.33-2.5V7z\"></path><circle cx=\"20.5\" cy=\"9.5\" r=\"2\"></circle><circle cx=\"20.5\" cy=\"20\" r=\"4.5\"></circle><circle cx=\"20.5\" cy=\"20\" r=\"1.75\"></circle>", 5)
  ]))]))
}
export default { render: render }